import React, { Component } from "react";
import { connect } from "react-redux";
import axios, { CancelToken } from "axios";

import { Translate, I18n } from "react-redux-i18n";
import { momentModule } from "../utils/Utils";

import { setAlert } from "../../actions/alertActions";

import MyEVs from "./insights/MyEVs";
import MostUsedEV from "./insights/MostUsedEV";
import MyChargers from "./insights/MyChargers";
import MyRating from "./insights/MyRating";
import MostUsedCP from "./insights/MostUsedCP";
import InsightsByEV from "./statistics/InsightsByEV";
import InsightsByCharger from "./statistics/InsightsByCharger";
import FavoriteCP from "./insights/FavoriteCP";

import "../../styles/components/insights/Insights.scss";
import arrow from "../../styles/images/arrow_long.svg";
import car from "../../styles/images/car_grey.svg";
import self from "../../styles/images/self_grey.svg";
import station from "../../styles/images/station_grey.svg";
import back from "../../styles/images/arrow_black.svg";

const { moment, formatDate } = momentModule;

class Insights extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;
    this.cancel = null;
    this.cancelDrivers = null;
    this.cancelInsights = null;

    this.state = {
      from: moment().subtract(1, "month").startOf("day"),
      to: moment().endOf("day"),
      mode: 1,
      isScrolled: false,
      driversFilter: ["all", "me"],
      fetchedInsights: null,

      loading: true,
      insights: null,

      evs: [],
      loadingEV: true,
      evData: null,

      chargers: [],
      loadingCharger: true,
      chargerData: null,

      myEvs: null,
      myChargers: null,
      myRating: 0,

      selectedEV: null,
      selectedDriver: "",
      selectedCharger: null,
    };

    this.fetchInsights = this.fetchInsights.bind(this);
    this.fetchInsightsByEv = this.fetchInsightsByEv.bind(this);
    this.fetchInsightsByCharger = this.fetchInsightsByCharger.bind(this);

    this.handleScroll = this.handleScroll.bind(this);
    this.switchMode = this.switchMode.bind(this);
    this.handleOnEVChange = this.handleOnEVChange.bind(this);
    this.handleUserFilterChange = this.handleUserFilterChange.bind(this);
    this.handleOnChargerChange = this.handleOnChargerChange.bind(this);
  }

  componentDidMount() {
    this._mounted = true;
    Promise.all([this.fetchEvs(), this.fetchChargers()]).then(
      ([evs = [], chargers = []]) => {
        this.safeSetState(
          {
            evs,
            chargers,
            selectedEV: 0,
            selectedCharger: 0,
          },
          this.fetchInsights
        );
      }
    );
  }

  componentWillUnmount() {
    this._mounted = false;
    if (this.cancel) this.cancel("Component is unmounting!");
    if (this.cancelDrivers) this.cancelDrivers("Component is unmounting!");
  }

  fetchEvs() {
    return axios
      .get("/api/private/fleets", {
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((res) => {
        if (res.status === 200) {
          return res.data.reduce(
            (flatEvList, fleet) => [...flatEvList, ...fleet.listEvs],
            []
          );
        }
      })
      .catch((err) =>
        this.props.setAlert(I18n.t(err.response.data.message), "danger")
      );
  }

  fetchChargers() {
    return axios
      .get("/api/private/infrastructure/myInfrastructure", {
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((res) => {
        if (res.status === 200) {
          return res.data.reduce(
            (flatChargerList, infrastructure) => [
              ...flatChargerList,
              ...infrastructure.listChargers,
            ],
            []
          );
        }
      })
      .catch((err) =>
        this.props.setAlert(I18n.t(err.response.data.message), "danger")
      );
  }

  fetchInsights() {
    if (this.cancel !== null) this.cancel("New request made");
    axios
      .get("/api/private/insights_v2", {
        params: {
          startDate: new Date(this.state.from),
          endDate: new Date(this.state.to),
        },
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((res) => {
        if (res.status === 200) {
          this.safeSetState({ loading: false, insights: res.data });
        }
      })
      .catch((err) =>
        this.props.setAlert(I18n.t(err.response.data.message), "danger")
      );
  }

  fetchInsightsByEv(callback) {
    if (this.cancelInsights !== null) this.cancelInsights("New request made");
    this.safeSetState(
      {
        loadingEV: true,
      },
      () =>
        axios
          .get("/api/private/insights_v2/byEV", {
            params: {
              startDate: new Date(this.state.from),
              endDate: new Date(this.state.to),
              evId:
                this.state.selectedEV !== "-1"
                  ? this.state.evs[this.state.selectedEV].evId
                  : "-1",
              driverId:
                this.state.evs[this.state.selectedEV]?.listOfDrivers[
                  this.state.selectedDriver
                ]?.userId,
            },
            cancelToken: new CancelToken((c) => (this.cancelInsights = c)),
          })
          .then((res) => {
            if (res.status === 200) {
              this.safeSetState(
                { evData: res.data, loadingEV: false },
                callback
              );
            }
          })
          .catch((err) =>
            this.props.setAlert(I18n.t(err.response.data.message), "danger")
          )
    );
  }

  fetchInsightsByCharger(callback) {
    if (this.cancelInsights !== null) this.cancelInsights("New request made");
    this.safeSetState(
      {
        loadingCharger: true,
      },
      () =>
        axios
          .get("/api/private/insights_v2/byCharger", {
            params: {
              startDate: new Date(this.state.from),
              endDate: new Date(this.state.to),
              hwId: this.state.chargers[this.state.selectedCharger].hwId,
            },
            cancelToken: new CancelToken((c) => (this.cancelInsights = c)),
          })
          .then((res) => {
            if (res.status === 200) {
              this.safeSetState(
                { chargerData: res.data, loadingCharger: false },
                callback
              );
            }
          })
          .catch((err) =>
            this.props.setAlert(I18n.t(err.response.data.message), "danger")
          )
    );
  }

  handleOnDateChange(e, date) {
    this.safeSetState(
      {
        [date]: moment(e.target.value)[date === "from" ? "startOf" : "endOf"](
          "day"
        ),
      },
      this.fetchInsights
    );
  }

  handleUserFilterChange(e) {
    this.safeSetState(
      {
        selectedDriver: e.target.value,
      },
      this.fetchInsightsByEv
    );
  }

  handleOnEVChange(e) {
    this.safeSetState(
      {
        selectedEV: e.target.value,
        selectedDriver: "",
      },
      this.fetchInsightsByEv
    );
  }

  handleOnChargerChange(e) {
    this.safeSetState(
      {
        selectedCharger: e.target.value,
      },
      this.fetchInsightsByCharger
    );
  }

  handleScroll(e) {
    this.safeSetState({
      isScrolled: e.target.scrollTop > 0 ? true : false,
    });
  }

  // Resets the state and fetches all when user switches from page to page.
  switchMode(mode) {
    //this.handleUserFilterChange({ target: { value: 0 } });
    this.safeSetState({ mode, isScrolled: false });
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  render() {
    const d = moment().startOf("day");
    const { loading, insights } = this.state;

    if (!loading) {
      return (
        <div id="insights" className="main-container insights">
          <div
            className={
              "control-bar " + (this.state.isScrolled ? "shadowed" : "")
            }
          >
            {this.state.mode !== 1 && (
              <button
                type="button"
                className="clear back"
                onClick={() => this.switchMode(1)}
              >
                <img src={back} alt="" />
              </button>
            )}
            {this.state.mode === 2 && (
              <>
                <div className="select-container">
                  <select
                    value={this.state.selectedEV}
                    onChange={this.handleOnEVChange}
                  >
                    <option value="-1">{I18n.t("insights_anonymous")}</option>
                    {this.state.evs.map((ev, idx) => {
                      return (
                        <option key={ev._id} value={idx}>
                          {ev.licensePlate}
                        </option>
                      );
                    })}
                  </select>
                  <img src={car} alt="" />
                </div>
                <div
                  className="select-container"
                  style={{ marginLeft: "1rem" }}
                >
                  <select
                    onChange={this.handleUserFilterChange}
                    value={this.state.selectedDriver}
                  >
                    <option key={0} value="">
                      {I18n.t("backOffice_insights_allKey")}
                    </option>
                    {this.state.evs?.[this.state.selectedEV]?.listOfDrivers
                      ?.filter((driver) => driver.userId)
                      .map((driver, idx) => (
                        <option key={idx + 1} value={idx}>
                          {driver.name}
                        </option>
                      ))}
                  </select>
                  <img src={self} alt="self img" />
                </div>
              </>
            )}
            {this.state.mode === 3 && (
              <div className="select-container">
                <select
                  value={this.state.selectedCharger}
                  onChange={this.handleOnChargerChange}
                >
                  {this.state.chargers.map((c, idx) => (
                    <option key={c._id} value={idx}>
                      {c.name}
                    </option>
                  ))}
                </select>
                <img src={station} alt="" />
              </div>
            )}
            <div
              className={
                "date-controls " + (this.state.mode !== 1 ? "right" : "")
              }
            >
              <div className="date-container">
                <input
                  type="date"
                  max={
                    this.state.to !== ""
                      ? moment(this.state.to).format("YYYY-MM-DD")
                      : ""
                  }
                  value={
                    this.state.from
                      ? moment(this.state.from).format("YYYY-MM-DD")
                      : ""
                  }
                  onChange={(e) => this.handleOnDateChange(e, "from")}
                />
                <input
                  type="text"
                  value={
                    this.state.from
                      ? formatDate(this.state.from, "date")
                      : I18n.t("insights_startDate")
                  }
                  readOnly
                />
              </div>
              <img src={arrow} alt="" />
              <div className="date-container">
                <input
                  type="date"
                  min={moment(
                    this.state.from !== "" ? this.state.from : d
                  ).format("YYYY-MM-DD")}
                  max={moment(d).format("YYYY-MM-DD")}
                  value={
                    this.state.to
                      ? moment(this.state.to).format("YYYY-MM-DD")
                      : ""
                  }
                  onChange={(e) => this.handleOnDateChange(e, "to")}
                />
                <input
                  type="text"
                  value={
                    this.state.to
                      ? formatDate(this.state.to, "date")
                      : I18n.t("insights_endDate")
                  }
                  readOnly
                />
              </div>
            </div>
          </div>
          {this.state.mode === 1 && (
            <div className="component-container grid">
              <MyEVs
                myEvs={insights.myEvs}
                counter={this.state.evs.length}
                hoverable={this.state.evs.length > 0}
                onClick={() => this.switchMode(2)}
                loading={loading}
              />
              <MostUsedEV ev={insights.mostUsedEV} loading={loading} />
              <FavoriteCP
                cp={insights.mostUsedChargerByMe}
                lastUsedCP={insights.lastUsedCharger}
                loading={loading}
              />
              <MyChargers
                myChargers={insights.myChargers}
                counter={this.state.chargers.length}
                hoverable={this.state.chargers.length > 0}
                onClick={() => this.switchMode(3)}
                loading={loading}
              />
              <MyRating myRating={insights.myRating} loading={loading} />
              <MostUsedCP cp={insights.mostUsedCharger} loading={loading} />
            </div>
          )}
          {this.state.mode === 2 && (
            <div className="component-container" onScroll={this.handleScroll}>
              {this.state.selectedEV === null && !this.props.loading ? (
                <Translate value="insightsByCharger_noEv" />
              ) : (
                <InsightsByEV
                  fetchInsights={this.fetchInsightsByEv}
                  data={this.state.evData}
                  evId={this.state.evs[this.state.selectedEV]?.evId ?? "-1"}
                  driverId={
                    this.state.evs[this.state.selectedEV]?.listOfDrivers[
                      this.state.selectedDriver
                    ]?.userId
                  }
                  from={this.state.from}
                  to={this.state.to}
                  loading={this.state.loadingEV}
                />
              )}
            </div>
          )}
          {this.state.mode === 3 && (
            <div className="component-container" onScroll={this.handleScroll}>
              <InsightsByCharger
                fetchInsights={this.fetchInsightsByCharger}
                data={this.state.chargerData}
                charger={this.state.chargers[this.state.selectedCharger]}
                from={this.state.from}
                to={this.state.to}
                loading={this.state.loadingCharger}
              />
            </div>
          )}
        </div>
      );
    } else
      return (
        <div className="loading-container">
          <div className="loading-spinner">
            <div className="generic-loading">
              <div></div>
              <div></div>
            </div>
          </div>
        </div>
      );
  }
}

const mapStateToProps = (state) => ({
  accountData: state.account.accountData,
});

export default connect(mapStateToProps, { setAlert })(Insights);
